import { useEffect } from 'react';

// this hook doesn't work, when you add the listener on element, which is part of array ...
export const useOnClickOutside = (
  ref: React.MutableRefObject<any>,
  handler: () => void,
) => {
  useEffect(() => {
    const listener = (event: any) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      // @ts-ignore
      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
